var _rect, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFromSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.4082,
    y: 0.474121,
    width: 7.56747,
    height: 8.4083,
    fill: "url(#from_solar_0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.98789,
    cy: 8.46201,
    r: 7.98789,
    fill: "url(#from_solar_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "from_solar_0",
    x1: 12.1919,
    y1: 0.474121,
    x2: 12.1919,
    y2: 8.88243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#179E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB416"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "from_solar_1",
    x1: 7.98789,
    y1: 0.474121,
    x2: 7.98789,
    y2: 16.4499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#179E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB416"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromSolar);
export default __webpack_public_path__ + "static/media/from-solar.c733c840759a6044b89cd6dc434f85d6.svg";
export { ForwardRef as ReactComponent };